import { css } from "@linaria/core";

import { units } from "@ui/css";
import { colors, fonts } from "@ui/kit/design-tokens";

export const tableOfContentsCls = css`
  margin: -0.2em auto;

  font-family: ${fonts.body()};
  font-size: ${units.font.px(16)};
  color: ${colors.text.primary()};
`;

export const listCls = css`
  padding: 0;
  list-style-type: disc;

  ol > li > & {
    padding-left: 30px;
  }
`;

export const linkCls = css`
  text-decoration: none;
  color: ${colors.text.primary()};

  transform: color 0.1s linear;

  &:hover {
    text-decoration: underline;
    color: ${colors.publisher()};
  }
`;
